import { Nullable } from '@/shared/types/app.types'
import { IncidentOriginResponse } from '@/modules/configurationModule/detail/incidents/incidents-origins/services/incidents-origins-laboratories.dto'

export enum ConfigurationIncidentsOriginsModalActiveTab {
    BASIC_DATA = 0,
    CONTACT_PERSONNEL = 1
}

export interface ConfigurationIncidentsOriginsContactPersonnelRelationships {
    active: boolean,
    personnelId: number,
    incidentOriginLaboratoryDefaultPersonnelId: Nullable<number>,
    fullName: string
}

export interface ConfigurationIncidentsOriginsModalState {
    id: Nullable<number>,
    activeTabIndex: ConfigurationIncidentsOriginsModalActiveTab,
    contactPersonnelFilter: string,
    basicData: {
        active: boolean,
        incidentOrigin: Nullable<IncidentOriginResponse>
    },
    contactPersonnel: ConfigurationIncidentsOriginsContactPersonnelRelationships[]
}
export const initialConfigurationIncidentsOriginsModalState =
    (): ConfigurationIncidentsOriginsModalState => ({
        id: null,
        activeTabIndex: ConfigurationIncidentsOriginsModalActiveTab.BASIC_DATA,
        contactPersonnelFilter: '',
        basicData: {
            active: true,
            incidentOrigin: null
        },
        contactPersonnel: []
    })
